import Common from './Common';
import { PLAYNC_DOMAIN, SERVICE, PLATFORM, getService, getIsPlayncDomain } from './const';

/*
  - l2m nct, j 제외한 ip(lw, tl 등): www.plaync.com 도메인으로 check, sso api 호출 (기존과 동일)
  - l2m nct, j
  (퍼플 런처) www.plaync.com 도메인으로 check, sso api 호출 
  (커뮤니티SDK) 
    (ncj) {공홈도메인(lineage2m.ncsoft.jp)}으로 check, sso api 호출 
    (nct) {공홈도메인(tw.ncsoft.com)}으로 check, sso api 호출 
  - l2m ncv: {공홈도메인(ncvgames.com)}으로 check, sso api 호출 
*/
export const getApiDomainByPlatform = () => {
  const { env, platform } = Common?.instance || {};

  const isPlayncDomain = getIsPlayncDomain();
  const service = getService();
  const isL2mNct = service === SERVICE.L2M_NCT;
  const isL2mNcj = service === SERVICE.L2M_NCJ;

  // l2m nct, j && 퍼플 런처
  if((isL2mNct || isL2mNcj) && platform === PLATFORM.PURPLE.LAUNCHER) {
    return PLAYNC_DOMAIN[env];
  }

  // .plaync.com 도메인이 아닌 경우
  if(!isPlayncDomain) {
    return `${location.origin}${isL2mNct ? '/lineage2m' : ''}`;
  }

  return PLAYNC_DOMAIN[env];
};

export const getSsoUrl = async(url) => {
    if(!url) {
        throw new Error(`url이 존재하지 않습니다.${e}`);
    }

    const domain = getApiDomainByPlatform();
    const encodeUrl = getEncodeUrl(url);

    return fetch(`${domain}/api/session/sso?return_url=${encodeUrl}`, {
        method: 'GET',
        credentials: 'include'
    })
    .then(res => res?.json())
    .catch(e => { throw new Error(`sso url api 호출에 실패하였습니다.\n${e}`); });
};

export const ssoUrlExternal = async(url) => {
    if(!url) {
        throw new Error(`url이 존재하지 않습니다.${e}`);
    }

    const { ssoUrl } = await getSsoUrl(url) || {};
    ssoUrl && window.open(ssoUrl, '_blank'); // 외부 브라우저로 이동
};

export const getEncodeUrl = (url) => {
    return encodeURIComponent(url);
};

export const checkHasParams = (url) => {
    let hasParam = false;
    let hasParams = false;

    if(url) {
        hasParam = (/\?.+/g).test(url); // query param 있는지 여부
        hasParams = (/\?(?=.*&).+/g).test(url); // param 2개 이상 있는지 여부
    }

    return { hasParam, hasParams };
};